import { get, writable } from 'svelte/store';

const ENERGY_SLOT_KEY = 'shelly_dev_energy_dashboard_promo_slot_v2';
const CUSTOM_SLOT_KEY = 'shelly_dev_custom_dashboard_promo_slot_v2';
const EMPTY_STATE_KEY = 'shelly_dev_dash_promo_empty_state';
const GLOBAL_INLINE_KEY = 'shelly_dev_global_inline_banners_v2';

const readBool = (key: string, defaultValue: boolean): boolean => {
	try {
		const stored = localStorage.getItem(key);
		if (stored === null) return defaultValue;
		return stored === 'true';
	} catch {
		return defaultValue;
	}
};

/** Master toggle for sample/generic GlobalInlineBanners. Default off. Verivox still shows for de_users. */
export const globalInlineBannersEnabled = writable<boolean>(readBool(GLOBAL_INLINE_KEY, false));

globalInlineBannersEnabled.subscribe((value) => {
	try {
		localStorage.setItem(GLOBAL_INLINE_KEY, String(value));
	} catch {
		// ignore
	}
});

/** Sample/generic promo slot on the Energy dashboard (-103). Default off. Verivox still shows for de_users. */
export const energyDashboardPromoSlotEnabled = writable<boolean>(readBool(ENERGY_SLOT_KEY, false));

energyDashboardPromoSlotEnabled.subscribe((value) => {
	try {
		localStorage.setItem(ENERGY_SLOT_KEY, String(value));
	} catch {
		// ignore
	}
});

/** Sample/generic promo slot on user-created custom dashboards. Default off. Verivox still shows for de_users. */
export const customDashboardPromoSlotEnabled = writable<boolean>(readBool(CUSTOM_SLOT_KEY, false));

customDashboardPromoSlotEnabled.subscribe((value) => {
	try {
		localStorage.setItem(CUSTOM_SLOT_KEY, String(value));
	} catch {
		// ignore
	}
});

/**
 * Dev-only: show the Promotions shop empty state when no banners are visible.
 * Default off — dismissing/clearing banners removes the widget / strip.
 */
export const dashPromoEmptyStateEnabled = writable<boolean>(readBool(EMPTY_STATE_KEY, false));

dashPromoEmptyStateEnabled.subscribe((value) => {
	try {
		localStorage.setItem(EMPTY_STATE_KEY, String(value));
	} catch {
		// ignore
	}
});

export const isGlobalInlineBannersEnabled = (): boolean => get(globalInlineBannersEnabled);

export const isEnergyDashboardPromoSlotEnabled = (): boolean => get(energyDashboardPromoSlotEnabled);

export const isCustomDashboardPromoSlotEnabled = (): boolean => get(customDashboardPromoSlotEnabled);

export const isDashPromoEmptyStateEnabled = (): boolean => get(dashPromoEmptyStateEnabled);
